<template>
  <div> <!-- Wrapper element, ideally should become a fragment when available -->
    <div class="h-100 d-flex align-items-center d-lg-none">
      <!-- Mobile progress bar -->
      <div class="flex-grow-1 mx-2 mx-sm-4">
        <div class="progress-indicator-container mr-auto ml-auto">
          <div class="progress-indicator mb-4">
            <span class="progress-indicator-number-container"
                  v-for="(step, index) in stepWithStates"
                  v-bind:key="index.name"
                  @click="!disabled && step.clickable && $emit('clickStep', index)"
                  v-bind:class="{ clickable: !disabled && step.clickable }">
              <span class="progress-indicator-number"
                    v-bind:class="{ active: index==currentStep, checked: index==currentStep && currentStepChecked }">{{index+1}}
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Desktop progress tracker with clickable elements -->
    <div class="d-none d-lg-block">
      <ul class="progress-tracker progress-tracker--text progress-tracker--text-top progress-tracker--center my-0 mx-auto">
        <li v-for="(step, index) in stepWithStates" :key="step.name"
            class="progress-step" :class="step.class || ''"
            @click="!disabled && step.clickable && $emit('clickStep', index)">
          <span class="progress-text">
            <h4 class="progress-title">{{step.label}}</h4>
          </span>
          <span class="progress-marker"></span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'progress-bar',
  props: {
    'steps': Array,
    'currentStep': Number,
    'currentStepChecked': Boolean,
    'disabled': Boolean
  },
  computed: {
    stepWithStates: function () {
      function stepState (step, currentStep, currentStepChecked) {
        let stepClass
        let clickable = true
        if (step === currentStep) {
          stepClass = currentStepChecked ? 'is-checked' : 'is-active'
        } else if (step < currentStep) {
          stepClass = 'is-complete'
        } else {
          clickable = false
        }
        return { 'class': stepClass, clickable }
      }
      return this.steps.map((step, index) => ({
        ...step,
        ...stepState(index, this.currentStep, this.currentStepChecked)
      }))
    },
    percentageComplete: function () {
      return Math.round(this.currentStep / (this.steps.length - 1) * 100)
    }
  }
}
</script>
